import type { BadgeVariant } from '../../components/ui';
import type { KhoaDich } from '../../i18n';
import type { LyDoMicro, LoiTep } from './nghiep-vu/bien-ban';
import type { TrangThaiPhien, TrangThaiTomTat } from './types';

/** Mã quyền nguyên văn của module (ADR-0126 mục 5). Thiếu quyền thì ẩn mục (ADR-UI-0005). */
export const QUYEN = {
  doc: 'bien-ban:phien:read',
  tao: 'bien-ban:phien:create',
  sua: 'bien-ban:phien:update',
  xoa: 'bien-ban:phien:delete',
} as const;

/**
 * Nhóm biến thể **trạng thái** của `Badge`: `primary` hệ thống đang làm, không ai phải làm gì; `success` dùng được;
 * `danger` cần người vào xem; `neutral` đang xếp hàng hoặc chưa có gì.
 */
export const NHAN_TRANG_THAI: Record<TrangThaiPhien, { khoa: KhoaDich; variant: BadgeVariant }> = {
  QUEUED: { khoa: 'bienBan.trangThai.QUEUED', variant: 'neutral' },
  TRANSCRIBING: { khoa: 'bienBan.trangThai.TRANSCRIBING', variant: 'primary' },
  SUMMARIZING: { khoa: 'bienBan.trangThai.SUMMARIZING', variant: 'primary' },
  DONE: { khoa: 'bienBan.trangThai.DONE', variant: 'success' },
  FAILED: { khoa: 'bienBan.trangThai.FAILED', variant: 'danger' },
};

/** Tóm tắt lỗi không làm hỏng phiên (ADR-0126 mục 4): bản chép lời vẫn dùng được, nên hổ phách. */
export const BADGE_TOM_TAT: Record<TrangThaiTomTat, { khoa: KhoaDich; variant: BadgeVariant }> = {
  NONE: { khoa: 'bienBanTomTat.trangThai.NONE', variant: 'neutral' },
  PENDING: { khoa: 'bienBanTomTat.trangThai.PENDING', variant: 'primary' },
  DONE: { khoa: 'bienBanTomTat.trangThai.DONE', variant: 'success' },
  FAILED: { khoa: 'bienBanTomTat.trangThai.FAILED', variant: 'warning' },
};

/**
 * Màu của người nói: nhóm biến thể **phân loại** của `Badge`, không dùng màu trạng thái (ai nói không phải tốt hay xấu).
 * Có bốn tông nên từ người thứ năm màu lặp lại, tên vẫn phân biệt được.
 */
export const MAU_NGUOI_NOI: ReadonlyArray<{ badge: BadgeVariant; vien: string }> = [
  { badge: 'violet', vien: 'border-violet-500' },
  { badge: 'teal', vien: 'border-teal-500' },
  { badge: 'orange', vien: 'border-orange-500' },
  { badge: 'info', vien: 'border-sky-500' },
];

export const KHOA_LOI_TEP: Record<LoiTep, KhoaDich> = {
  'sai-dinh-dang': 'bienBanTai.loiSaiDinhDang',
  'qua-lon': 'bienBanTai.loiQuaLon',
  rong: 'bienBanTai.loiTepRong',
};

export const KHOA_LOI_MICRO: Record<LyDoMicro, KhoaDich> = {
  KHONG_HO_TRO: 'bienBanGhiAm.loi.KHONG_HO_TRO',
  KHONG_BAO_MAT: 'bienBanGhiAm.loi.KHONG_BAO_MAT',
  TU_CHOI: 'bienBanGhiAm.loi.TU_CHOI',
  KHONG_CO_THIET_BI: 'bienBanGhiAm.loi.KHONG_CO_THIET_BI',
  DANG_BAN: 'bienBanGhiAm.loi.DANG_BAN',
  KHONG_CO_TIENG: 'bienBanGhiAm.loi.KHONG_CO_TIENG',
  KHAC: 'bienBanGhiAm.loi.KHAC',
};
